var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotepad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.77 2.50002H19.2503V1.90377C19.2503 0.852129 18.3981 0 17.3465 0H8.654C7.60241 0 6.75023 0.852129 6.75023 1.90377V2.50002H3.23003C1.72218 2.50002 0.500031 3.72217 0.500031 5.23002V27.27C0.500031 28.7779 1.72218 30 3.23003 30H22.7701C24.2779 30 25.5001 28.7779 25.5001 27.27V5.23002C25.5 3.72217 24.2778 2.50002 22.77 2.50002ZM9.25025 2.50002H16.75V5.00004H9.25025V2.50002ZM23 27.27C23 27.3971 22.8972 27.5 22.7701 27.5H3.23003C3.10288 27.5 3.00005 27.3971 3.00005 27.27V5.23002C3.00005 5.10287 3.10288 5.00004 3.23003 5.00004H6.75005V5.59629C6.75005 6.64787 7.60218 7.50006 8.65382 7.50006H8.65405H17.3463H17.3466C18.3981 7.50006 19.2503 6.64793 19.2503 5.59629V4.99998H22.7701C22.8972 4.99998 23 5.10281 23 5.22996V27.27Z",
    fill: "#0095FF",
    stroke: "#0095FF",
    strokeWidth: 0.00064
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 11.25H11.75C11.0597 11.25 10.5001 11.8096 10.5001 12.5C10.5001 13.1903 11.0597 13.75 11.75 13.75H19.25C19.9404 13.75 20.5 13.1903 20.5 12.5C20.5 11.8096 19.9404 11.25 19.25 11.25Z",
    fill: "#0095FF",
    stroke: "#0095FF",
    strokeWidth: 0.00064
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 16.25H11.75C11.0597 16.25 10.5001 16.8096 10.5001 17.5C10.5001 18.1903 11.0597 18.75 11.75 18.75H19.25C19.9404 18.75 20.5 18.1903 20.5 17.5C20.5 16.8097 19.9404 16.25 19.25 16.25Z",
    fill: "#0095FF",
    stroke: "#0095FF",
    strokeWidth: 0.00064
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 21.25H11.75C11.0597 21.25 10.5001 21.8096 10.5001 22.5C10.5001 23.1903 11.0597 23.75 11.75 23.75H19.25C19.9404 23.75 20.5 23.1903 20.5 22.5C20.5 21.8096 19.9404 21.25 19.25 21.25Z",
    fill: "#0095FF",
    stroke: "#0095FF",
    strokeWidth: 0.00064
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74998 11.25C6.05998 11.25 5.5 11.81 5.5 12.5C5.5 13.19 6.05998 13.75 6.74998 13.75C7.43998 13.75 7.99996 13.19 7.99996 12.5C7.99996 11.81 7.43998 11.25 6.74998 11.25Z",
    fill: "#0095FF",
    stroke: "#0095FF",
    strokeWidth: 0.00064
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74998 16.25C6.05998 16.25 5.5 16.81 5.5 17.5C5.5 18.19 6.05998 18.75 6.74998 18.75C7.43998 18.75 7.99996 18.19 7.99996 17.5C7.99996 16.81 7.43998 16.25 6.74998 16.25Z",
    fill: "#0095FF",
    stroke: "#0095FF",
    strokeWidth: 0.00064
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74998 21.25C6.05998 21.25 5.5 21.81 5.5 22.5C5.5 23.19 6.05998 23.75 6.74998 23.75C7.43998 23.75 7.99996 23.19 7.99996 22.5C7.99996 21.81 7.43998 21.25 6.74998 21.25Z",
    fill: "#0095FF",
    stroke: "#0095FF",
    strokeWidth: 0.00064
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotepad);
export default __webpack_public_path__ + "static/media/iconNotepad.d9d0c88e309e03ed26ce53b4f751d37d.svg";
export { ForwardRef as ReactComponent };